<template>
  <div class="person-query-container">
    <el-card class="query-card">
      <div slot="header" class="clearfix">
        <span class="section-title">人员信息查询</span>
        <!-- <span class="query_card"></span> -->
      </div>
      <el-form :model="queryForm" label-width="100px" class="query-form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="姓名:">
              <el-input v-model="queryForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号:">
              <el-input v-model="queryForm.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="年龄段:">
              <el-select v-model="queryForm.ageRange" placeholder="请选择年龄段" clearable style="width: 100%">
                <el-option v-for="item in ageRangeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="查询类型:">
              <el-select v-model="queryForm.queryType" placeholder="请选择查询类型" clearable style="width: 100%"
                @change="handleQueryTypeChange">
                <el-option label="全部" value="0"></el-option>
                <el-option label="本月享受" value="1"></el-option>
                <el-option label="本月新增" value="2"></el-option>
                <el-option label="本月暂停" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="个人状态:">
              <el-select v-model="queryForm.status" placeholder="请选择个人状态" clearable style="width: 100%">
                <el-option v-for="item in dynamicStatusOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


        </el-row>

        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="handleQuery(true)">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="result-card">
      <div slot="header" class="clearfix flex">
        <span class="section-title">查询结果</span>
        <el-button style="" type="primary" @click="handleExport">导出</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="name" label="姓名" width="120">
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="180">
          <template slot-scope="scope">
            {{ scope.row.idCard || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="地址" width="260">
          <template slot-scope="scope">
            <div>{{ formatAddress(scope.row) }}</div>
            <div v-if="scope.row.address">{{ scope.row.address }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="个人状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bankName" label="银行名称" width="150">
          <template slot-scope="scope">
            {{ scope.row.bankName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bankNum" label="银行账号" width="200">
          <template slot-scope="scope">
            {{ scope.row.bankNum || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUser" label="更新人员" width="120">
          <template slot-scope="scope">
            {{ scope.row.updateUser || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updateTime) }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
        style="margin-top: 20px; text-align: right">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PersonQuery',
  data() {
    return {
      queryForm: {
        name: '',
        idCard: '',
        status: '',
        queryType: '0',
        ageRange: '0,200'
      },
      statusOptions: [
        { value: '', label: '全部' },
        { value: -1, label: '身份信息有误' },
        { value: 0, label: '待验证' },
        { value: 1, label: '验证中' },
        { value: 2, label: '正常' },
        { value: 4, label: '迁出' },
        { value: 6, label: '死亡' }
      ],
      dynamicStatusOptions: [
        { value: '', label: '全部' },
        { value: -1, label: '身份信息有误' },
        { value: 0, label: '待验证' },
        { value: 2, label: '正常' },
        { value: 4, label: '迁出' },
        { value: 6, label: '死亡' }
      ],
      ageRangeOptions: [
        { value: '0,200', label: '全部' },
        { value: '80,200', label: '大于80岁' },
        { value: '80,89', label: '80-89岁' },
        { value: '90,99', label: '90-99岁' },
        { value: '100,200', label: '大于100岁' }
      ],
      tableData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    // this.handleQuery();
  },
  methods: {
    async handleQuery(resetPage = false) {
      this.loading = true;
      try {
        // 从本地存储获取用户名
        const userName = localStorage.getItem('userName') || sessionStorage.getItem('user') || '';

        // 需要时重置到第一页
        if (resetPage) {
          this.pagination.currentPage = 1;
        }

        // 构建查询参数
        const params = {
          userName: userName,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          name: this.queryForm.name,
          idCard: this.queryForm.idCard,
          status: this.queryForm.status,
          queryType: this.queryForm.queryType,
          ageRange: this.queryForm.ageRange
        };

        // 调用真实接口
        const response = await axios.post('https://back.rensheju.com/instant/query/result', params);

        if (response.data && response.data.code === 200) {
          // 处理返回的数据结构
          const responseData = response.data.data;
          this.tableData = responseData.content || [];
          this.pagination.total = responseData.totalSize || 0;

          // 如果返回的数据为空，显示提示
          if (this.tableData.length === 0) {
            this.$message.info('暂无查询结果');
          }
        } else {
          this.$message.error(response.data.message || '查询失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (error) {
        console.error('查询失败:', error);
        this.$message.error('查询失败，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleReset() {
      this.queryForm = {
        name: '',
        idCard: '',
        status: '',
        queryType: '0',
        ageRange: '0,200'
      };
      this.pagination.currentPage = 1;
      // 重置后不自动查询，让用户手动点击查询按钮
    },
    async handleExport() {
      try {
        // 检查表格是否有数据
        if (!this.tableData || this.tableData.length === 0) {
          this.$message.warning('当前表格没有数据，请先查询后再导出');
          return;
        }

        const userName = localStorage.getItem('userName') || sessionStorage.getItem('user') || '';

        // 导出前校验：根据返回code决定是否继续
        let allow = true;
        try {
          const verifyRes = await axios.get('https://back.rensheju.com/instant/query/isALLVerify', { params: { userName } });
          const data = verifyRes && verifyRes.data ? verifyRes.data : {};
          const code = data.code;

          if (code === 200) {
            // 正常，继续导出
            allow = true;
          } else if (code === 500) {
            // 500错误，显示message内容
            try {
              await this.$confirm(data.message || '还有用户未验证，是否继续下载', '提示', {
                confirmButtonText: '继续下载',
                cancelButtonText: '取消',
                type: 'warning'
              });
            } catch (e) {
              allow = false;
            }
          } else {
            // 其他错误，提示系统错误
            this.$message.error('系统错误，无法导出');
            return;
          }
        } catch (e) {
          this.$message.error('系统错误，无法导出');
          return;
        }

        if (!allow) {
          this.$message.info('已取消下载');
          return;
        }

        // 构建导出参数（与查询参数相同）
        const params = {
          userName: userName,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          name: this.queryForm.name,
          idCard: this.queryForm.idCard,
          status: this.queryForm.status,
          queryType: this.queryForm.queryType,
          ageRange: this.queryForm.ageRange
        };

        await this.doExport(params);
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },
    async doExport(params) {
      try {
        // validateStatus: 接收非200响应，方便自定义处理
        const response = await axios.post('https://back.rensheju.com/instant/query/export', params, {
          responseType: 'blob',
          validateStatus: () => true
        });

        // 1) 先看HTTP状态码
        if (response.status !== 200) {
          // 尝试从blob中解析出错误信息
          try {
            const text = await response.data.text();
            let msg = '导出失败';
            try {
              const j = JSON.parse(text);
              const code = j.code || j.status;
              msg = j.message || j.msg || (code ? `导出失败，状态码：${code}` : msg);
            } catch (e) {
              // 非JSON，保持默认
            }
            this.$message.error(msg);
          } catch (e) {
            this.$message.error('导出失败');
          }
          return;
        }

        // 2) HTTP为200，再看内容是否是错误JSON
        const contentType = (response.headers && (response.headers['content-type'] || response.headers['Content-Type'])) || '';
        if (contentType.indexOf('application/json') !== -1) {
          const text = await response.data.text();
          try {
            const j = JSON.parse(text);
            const code = j.code || j.status;
            if (code && code !== 200) {
              this.$message.error(j.message || j.msg || '导出失败');
              return;
            }
          } catch (e) {
            // JSON解析失败则按正常文件处理
          }
        }

        // 3) 通过校验，执行下载
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const fileName = `人员信息查询结果_${new Date().toISOString().slice(0, 10)}.xlsx`;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1; // 重置到第一页
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.handleQuery();
    },
    handleQueryTypeChange(value) {
      if (value === '1') { // 本月享受
        this.dynamicStatusOptions = [
          { value: '', label: '全部' },
          { value: 2, label: '正常' }
        ];
      } else if (value === '2') { // 本月新增
        this.dynamicStatusOptions = [
          { value: '', label: '全部' },
          { value: -1, label: '身份信息有误' },
          { value: 0, label: '待验证' },
          { value: 1, label: '验证中' },
          { value: 2, label: '正常' },
          { value: 4, label: '迁出' },
          { value: 6, label: '死亡' }
        ];
      } else if (value === '3') { // 本月暂停
        this.dynamicStatusOptions = [
          { value: '', label: '全部' },
          { value: 4, label: '迁出' },
          { value: 6, label: '死亡' }
        ];
      } else { // 全部
        this.dynamicStatusOptions = [
          { value: '', label: '全部' },
          { value: -1, label: '身份信息有误' },
          { value: 0, label: '待验证' },
          { value: 1, label: '验证中' },
          { value: 2, label: '正常' },
          { value: 4, label: '迁出' },
          { value: 6, label: '死亡' }
        ];
      }
      this.queryForm.status = ''; // 清空个人状态，让用户重新选择
    },
    getStatusText(status) {
      const statusMap = {
        '-1': '身份信息有误',
        '0': '待验证',
        '1': '验证中',
        '2': '正常',
        '4': '迁出',
        '6': '死亡'
      };
      return statusMap[status] || '未知';
    },
    getStatusTagType(status) {
      const typeMap = {
        '-1': 'danger',
        '0': 'warning',
        '1': 'info',
        '2': 'success',
        '4': 'info',
        '6': 'danger'
      };
      return typeMap[status] || 'info';
    },
    formatAddress(row) {
      const addressParts = [];
      if (row.province) addressParts.push(row.province);
      if (row.city) addressParts.push(row.city);
      if (row.county) addressParts.push(row.county);
      if (row.town) addressParts.push(row.town);
      if (row.village) addressParts.push(row.village);

      return addressParts.length > 0 ? addressParts.join('') : '-';
    },
    formatDate(value) {
      if (!value) return '-';
      if (typeof value === 'string') {
        const tIndex = value.indexOf('T');
        if (tIndex !== -1) {
          return value.slice(0, 10);
        }
        return value.slice(0, 10);
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) return '-';
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
  }
}
</script>

<style scoped>
.person-query-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 40px);
}

.query-card {
  margin-bottom: 20px;
  border-radius: 15px;
}

.result-card {
  margin-top: 20px;
  border-radius: 15px;
}

.query-form {
  padding: 20px 0;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-left: 4px solid #409EFF;
  padding-left: 12px;
  letter-spacing: 1px;
}
</style>


// WEBPACK FOOTER //
// src/views/Myvue/withoutReviewQuery.vue